export default __webpack_public_path__ + "static/media/Vaca.22d8693b.jpeg";